import { dictionary } from '../../../../../utils/dictionary';
import { useAuth } from '../../../../../context/AuthContext';
import type { MethodType } from '../types';

interface MethodSelectorProps {
  currentMethod: MethodType | null;
  onSelect: (method: MethodType) => void;
  disabled?: boolean;
}

const LinkIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
  </svg>
);

const ManualIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const PreviousIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const btnClass = (active: boolean, disabled: boolean) =>
  `px-5 py-2 rounded-full font-medium transition-all border-2 flex items-center gap-2 ${
    disabled ? 'opacity-60 pointer-events-none ' : ''
  }${active ? 'bg-[#2B3674] text-white border-[#2B3674]' : 'bg-white text-gray-700 border-gray-200 hover:border-gray-300'}`;

export function MethodSelector({ currentMethod, onSelect, disabled = false }: MethodSelectorProps) {
  const { language } = useAuth();

  return (
    <div className="flex gap-2 justify-center mt-6">
      <div className="flex gap-3 justify-center mb-6">
        <button type="button" disabled={disabled} onClick={() => onSelect('link')} className={btnClass(currentMethod === 'link', disabled)}>
          <LinkIcon />
          {dictionary['link'][language]}
        </button>
        <button type="button" disabled={disabled} onClick={() => onSelect('manual')} className={btnClass(currentMethod === 'manual', disabled)}>
          <ManualIcon />
          {dictionary['upload-photo'][language]}
        </button>
        <button type="button" disabled={disabled} onClick={() => onSelect('previous')} className={btnClass(currentMethod === 'previous', disabled)}>
          <PreviousIcon />
          {dictionary['your-products'][language]}
        </button>
      </div>
    </div>
  );
}
